// extracted by mini-css-extract-plugin
module.exports = {"ds-divider":"Divider_ds-divider__taJ0A"};